import { render } from "./PaidSearchAdAgencyPage.vue?vue&type=template&id=137bfe74&ts=true"
import script from "./PaidSearchAdAgencyPage.vue?vue&type=script&lang=ts"
export * from "./PaidSearchAdAgencyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__